define(
({
	buttonOk: "ตกลง",
	buttonCancel: "ยกเลิก",
	buttonSave: "บันทึก",
	itemClose: "ปิด"
})
);
